import {FormProps} from "../../core/form/formUtils";
import React from "react";
import {ProjectVersion} from "../domain/project/projectVersionDomain";
import {ProjectVersionRoom} from "../domain/project/projectVersionRoomDomain";
import {DefinitionType} from "../../core/form/form";
import {MdTextField} from "../../core/components/fields/fields";
import {Validate} from "../../core/form/validate";
import StyledSelect from "../../core/components/fields/styledSelect";
import {ClosedFormBlock, ClosedFormBlockProps, ClosedFormField} from "../../core/form/closedForm";
import {createForm} from "../../core/form/createForm";
import {observer} from "mobx-react";
import {optionsSearch} from "../../core/common/service/commonDataService";
import {PROJECT_VERSION_ROOM_CATEGORY_ENTITY, PROJECT_VERSION_ROOM_TYPE_ENTITY} from "../entityConstants";

@observer
class ProjectVersionRoomForm extends React.Component<FormProps<ProjectVersionRoom, ProjectVersion>, undefined> {


  render(): JSX.Element | false | null {
    let {dataObject} = this.props;
    let fields = dataObject.getFormFields(ProjectVersionRoomFormDefinition.formName);
    let {roomName, roomNumber, roomType, radonExposureLevel, roomCategory, area} = fields;

    return (
      <div>
        <div className="row">
          <div className="fx col-xs-2 col-sm-2">
            <MdTextField {...roomName.props} />
            <Validate field={roomName} value={roomName.props.value}/>
          </div>
          <div className="fx col-xs-2 col-sm-2">
            <MdTextField {...roomNumber.props} />
            <Validate field={roomNumber} value={roomNumber.props.value}/>
          </div>
          <div className="fx col-xs-2 col-sm-2">
            <MdTextField {...area.props} />
            <Validate field={area} value={area.props.value}/>
          </div>
          <div className="fx col-xs-2 col-sm-2">
            <StyledSelect {...roomType.props} async={true} loadOptions={optionsSearch.bind(this, PROJECT_VERSION_ROOM_TYPE_ENTITY, {})} clearable asterixForAll/>
            <Validate field={roomType} value={roomType.props.value}/>
          </div>
          <div className="fx col-xs-2 col-sm-2">
            <StyledSelect {...roomCategory.props} async={true} loadOptions={optionsSearch.bind(this, PROJECT_VERSION_ROOM_CATEGORY_ENTITY, {})} clearable asterixForAll/>
            <Validate field={roomCategory} value={roomCategory.props.value}/>
          </div>
          <div className="fx col-xs-2 col-sm-2">
            <StyledSelect {...radonExposureLevel.props} />
            <Validate field={radonExposureLevel} value={radonExposureLevel.props.value}/>
          </div>
        </div>
      </div>
    );
  }
}

const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedFormBlockProps<ProjectVersionRoom>) => (
  <div style={{width: '100%'}}>
    <ClosedFormBlock {...{dataObject, entity, entities, fields}} >
      <ClosedFormField label={fields.roomName.textLabel} value={dataObject.roomName}/>
      <ClosedFormField label={fields.roomType.textLabel} value={dataObject.roomType}/>
      <ClosedFormField label={fields.roomCategory.textLabel} value={dataObject.roomCategory}/>
      <ClosedFormField label={fields.radonExposureLevel.textLabel} value={dataObject.radonExposureLevel}/>
    </ClosedFormBlock>
  </div>
);

export const ProjectVersionRoomFormDefinition: DefinitionType = {
  formName: 'ProjectVersionRoomForm',
  fields: [
    {name : 'roomName', validators : ['IsRequired']},
    {name : 'roomNumber', validators : ['IsRequired']},
    {name : 'roomType', validators : ['IsRequired']},
    {name : 'area', validators : ['IsRequired', 'IsNumber', {validation: 'Min', parameters: {min: 0}}]},
    {name : 'roomCategory', validators: ['IsRequired']},
    {name : 'radonExposureLevel', validators : ['IsRequired']}
  ]
};

export default createForm(ProjectVersionRoomFormDefinition, ClosedContent)(ProjectVersionRoomForm);



// WEBPACK FOOTER //
// ./src/sbtool/component/projectVersionRoomForm.tsx